import React from 'react';
import { ShieldCheck } from 'lucide-react';
import styles from './BannerOverlayHero.module.css';

const BannerOverlayHero = ({
  badge,
  scriptTitle,
  boldTitle,
  descriptions,
  features,
  bannerImage,
  accentImage,
}) => {
  const leadParagraph = descriptions[0];
  const supportParagraphs = descriptions.slice(1, 2);

  return (
    <section className={styles.heroSection}>
      <img
        className={styles.bgImage}
        src={bannerImage.src}
        alt=""
        aria-hidden="true"
        loading="eager"
      />
      <div className={styles.overlay} aria-hidden="true" />

      <div className={styles.inner}>
        <div className={styles.layout}>
          <div className={styles.contentCard}>
            <span className={styles.badge}>{badge}</span>

            <div className={styles.titleBlock}>
              <span className={styles.eyebrow}>{scriptTitle}</span>
              <h1 className={styles.title}>{boldTitle}</h1>
            </div>

            {leadParagraph && <p className={styles.lead}>{leadParagraph}</p>}

            {supportParagraphs.length > 0 && (
              <div className={styles.bodyCopy}>
                {supportParagraphs.map((text, index) => (
                  <p key={index} className={styles.paragraph}>
                    {text}
                  </p>
                ))}
              </div>
            )}

            {features?.length > 0 && (
              <div className={styles.featureSection}>
                <p className={styles.featureLabel}>Key highlights</p>
                <ul className={styles.featureRow}>
                  {features.map((feature, index) => (
                    <li key={index} className={styles.featureChip}>
                      <ShieldCheck size={13} aria-hidden="true" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {accentImage && (
            <div className={styles.visualPanel} aria-hidden="true">
              <div className={styles.bentoWrap}>
                <div className={styles.bentoMain}>
                  <img src={accentImage.src} alt={accentImage.alt} />
                </div>
                <div className={styles.bentoSide}>
                  <div className={styles.bentoTile}>
                    <img src={bannerImage.src} alt="" />
                  </div>
                  <div className={styles.bentoTile}>
                    <img src={accentImage.src} alt="" />
                  </div>
                </div>
              </div>
              <span className={styles.cornerAccentTop} />
              <span className={styles.cornerAccentBottom} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default BannerOverlayHero;
